import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
import checkIcon from "../../../resources/images/check-blue.svg";

const styles = createUseStyles(theme => ({
  modalContent: {
    margin: "20px 0 0 0"
  },
  listContainer: {
    overflow: "auto",
    maxHeight: "385px",
    "&::-webkit-scrollbar": {
      display: "none",
    }
  },
  checkBoxDiv: {
    marginLeft: "auto"
  },
  boldPar: {
    fontWeight:"600 !important",
  },
  assignModal: {
    width: "480px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      marginBottom: "12px"
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight:"400",
      lineHeight:"20px",
    },
    "& .modal-body": {
      padding: "0px 24px 24px",

    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  btnContainer:{
    marginTop:"32px"
  },

  optionContainer:{
    cursor: "pointer",
    display:"flex",
    flexDirection:"row",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px",
    marginBottom:"12px",
    "&:hover": {
      border: theme.modal.optionHover.border,
      "& input":{
        backgroundColor: theme.modal.optionHover.backgroundColor,
         border: theme.checkbox.border,
      },
    },
    "& h3":{
      fontSize:"14px",
      fontWeight:"500",
      lineHeight:"20px",
      color: colors.grey,
      margin:"0px"
    },
    "& p":{
      fontSize:"14px",
      fontWeight:"400",
      lineHeight:"20px",
      color: colors.mediumGrey,
      margin:"0px"
    },
    "& input":{
      appearance: "none",
      width: "16px",
      height: "16px",
      border: "1px solid " + colors.lightGrey,
      borderRadius: "4px",
      cursor: "pointer",
      "&:checked": {
        border: theme.checkbox.border,
        backgroundColor: theme.checkbox.backgroundColor,
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundColor: theme.checkbox.iconColor,
          maskImage: `url(${checkIcon})`,
          WebkitMaskImage: `url(${checkIcon})`,
          maskSize: "10px 10px",
          maskPosition: "center",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "10px 10px",
          WebkitMaskPosition: "center",
          WebkitMaskRepeat: "no-repeat",
        },
      }
    },
  },
  disabledContainer: {
    backgroundColor: colors.brightBlue,
    cursor: "not-allowed",
    "&:hover": {
      border: "1px solid" + colors.gray100,
      "& input":{
        backgroundColor: "inherit",
        border: "1px solid " + colors.gray100,
        cursor: "not-allowed",
      },
    },
  },
  selectedOptionContainer:{
    border: theme.modal.selectedOption.border,
    backgroundColor: theme.modal.selectedOption.backgroundColor,
    color: theme.modal.selectedOption.text.color,
    padding: "15px",
    "&:hover": {
      border: theme.modal.selectedOption.border,
    },
    "& h3":{
      color: theme.modal.selectedOption.text.color
    },
    "& p":{
      color: theme.modal.selectedOption.text.color
    },
  },
  logo:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "32px",
    height: "32px",
    padding: "12px",
    borderRadius:"16px",
    backgroundColor: colors.gray100,
    color: colors.mediumGrey,
    "& svg": {
      width: "16px",
      height: "16px",
    }
  },
  textContainer:{
    marginLeft:"16px",
    marginRight:"4px"
  },

  cancelBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center"
  },
  createBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  colCancel:{
    padding:"0px",
    marginRight:"6px"
  },
  colRemove:{
    padding:"0px"
  },
  btnsRow: {
    flexWrap: "nowrap"
  },
}));

export default styles;
